import { getWords } from './_internal/getWords.mjs';

const snakeCase = (str) => {
    const words = getWords(str);
    return words.map(word => word.toLowerCase()).join('_');
};

export { snakeCase };
